// extracted by mini-css-extract-plugin
export default {"buttonContainer":"yF21d","alignToEdge":"iwksg","buttonIcon":"BlpHO","buttonCaption":"g1mOj","buttonSpacer":"HycP5"};